class Accordion extends ViewBasic {
	constructor(options) {
		super(options);

		this.$expandableArea = this.$('.accordion-wrapper');
		this.$toggler = this.$('.accordion-trigger');
		this.$content = this.$('.accordion-content');

		this.animated = false;

		Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
	}

	init(){
		// this.addEvents();
	}

	addEvents() {
		this.$toggler.on('click', e => this.handleExpand(e));
	}

	removeEvents() {
		this.$toggler.off('click');
		Me.dispatch.unsubscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
	}

	handleExpand(e){
		if(this.animated)
			return;

		this.animated = true;
		this.$expandableArea.toggleClass('open');
		this.$content.slideToggle(250, e => {this.animated = false});
	}

	handleBreakpoints(e, params){
		if(params.breakpoint !== '767-'){
			this.$content.removeAttr('style');
		}

		if(this.options.breakpoint){
			if(Me.help.dimension.getTotalW() < this.options.breakpoint){
				this.addEvents();
			} else{
				this.removeEvents();
			}
		} else {
			this.removeEvents();
			this.addEvents();
		}
	}
}